import Theme from 'Theme';
import { StyleSheet } from 'react-native';
import { Device } from 'DeviceUtils';
import type { StylesMap } from 'Types';

type StylesProps = {
    isPlayerInfo?: boolean;
};

const getStyles = ({ isPlayerInfo }: StylesProps = {}): StylesMap => {
    let styles: StylesMap = {
        itemValue: {
            fontFamily: Theme.regularFont,
            color: Theme.primaryTextColor,
            fontSize: Theme.fontSizes.description,
            lineHeight: 28
        },
        itemValueLink: {
            fontFamily: Theme.regularFont,
            color: Theme.primaryLinkColor,
            fontSize: Theme.fontSizes.description,
            lineHeight: 28
        }
    };

    if (isPlayerInfo)
        styles = {
            ...styles,
            itemValue: {
                fontFamily: Theme.regularFont,
                color: Theme.primaryTextColor,
                fontSize: Theme.fontSizes.description,
                lineHeight: 22
            },
            itemValueLink: {
                fontFamily: Theme.regularFont,
                color: Theme.primaryLinkColor,
                fontSize: Theme.fontSizes.description,
                lineHeight: 22
            }
        };

    if (Device.isWeb)
        styles = {
            ...styles,
            itemValue: {
                color: Theme.primaryTextColor,
                fontFamily: Theme.regularFont,
                fontSize: 18,
                lineHeight: 28
            }
        };

    return StyleSheet.create(styles);
};

export default getStyles;
